import {Injectable} from '@angular/core';

@Injectable()
export class NotificationService {

    HIDE_MESSAGE_DELAY: number;
    toastDto: any;
    INFO_TYPE: string = "INFO";
    ERROR_TYPE: string = "ERROR";
    SUCCESS_TYPE: string = 'SUCCESS';
    toastVisible: boolean;
    timeOut: number;

    constructor() {
        this.HIDE_MESSAGE_DELAY = 5000;
        this.toastDto = this.buildToast(null, null, null, null, null);
        this.toastVisible = false;
    }

    isToastVisible() {
        return this.toastVisible;
    }

    setHideMessageDelay(delay){
        this.HIDE_MESSAGE_DELAY = delay;
    }

    private buildToast(title, message, params, type, errorList) {
        return {
            toastTitle: title,
            toastMessage: message,
            toastMessageParameters: params,
            type: type,
            messageList: errorList
        }
    }

    displayToast(title, message, params, type) {
        this.toastDto = this.buildToast(title, message, params, this.INFO_TYPE, null);
        this.toastVisible = true;
        this.setTimeOutToHideToast(null);
    }

    showToast(title, message, params, type, hideMessageDelay) {
        this.toastDto = this.buildToast(title, message, params, type, null);
        this.toastVisible = true;
        this.setTimeOutToHideToast(hideMessageDelay);
    }

    closeToast() {
        this.toastVisible = false;
        this.toastDto = this.buildToast(null, null, null, null, null);
    };


    getToast() {
        return (this.toastDto);
    }

    //Handle old methods

    notifySuccessByCode(title, message, hideMessageDelay) {
        this.toastDto = this.buildToast(title, message, null, this.SUCCESS_TYPE, null);
        this.toastVisible = true;
        this.setTimeOutToHideToast(hideMessageDelay);
    };

    notifyInfoByCode(messageCode) {
        this.toastDto = this.buildToast(messageCode, null, null, this.INFO_TYPE, null);
        this.toastVisible = true;
        this.setTimeOutToHideToast(null);
    };

    notifyErrorByCode(messageCode) {
        this.toastDto = this.buildToast(messageCode, null, null, this.ERROR_TYPE, null);
        this.toastVisible = true;
        this.setTimeOutToHideToast(null);
    };

    notifyErrorByCodeWithParams(messageCode, params) {
        this.toastDto = this.buildToast(messageCode, null, params, this.ERROR_TYPE, null);
        this.toastVisible = true;
        this.setTimeOutToHideToast(null);
    };

    notifyErrorByCodeWithMessageAndErrorList(messageCode, errorList) {
        this.toastDto = this.buildToast(messageCode, null, null, this.ERROR_TYPE, errorList);
        this.toastVisible = true;
        this.setTimeOutToHideToast(null);
    };

    notifyFrontErrorDetailByCodes(errorList) {
        this.toastDto = this.buildToast("Error", null, null, this.ERROR_TYPE, errorList);
        this.toastVisible = true;
        this.setTimeOutToHideToast(null);
    }

    notifyFormErrors(errors) {
        let errorsList = [];
        if (!!errors) {
            if (!!errors.required) {
                errorsList.push("common.form.validation.UNCOMPLETE_REQUIRED_FIELD");
            }
            if (!!errors.invalidAmountFormat || !!errors.number) {
                errorsList.push("warning.invalidNumberFormat");
            }
            if (!!errors.additionalErrors && errors.additionalErrors.length > 0) {
                errorsList = errorsList.concat(errors.additionalErrors);
            }
            if (errorsList.length > 0) {
                this.notifyFrontErrorDetailByCodes(errorsList);
            }
        }
    }

    private setTimeOutToHideToast(hideMessageDelay) {
        if (!!this.timeOut) {
            window.clearTimeout(this.timeOut);
            delete this.timeOut;
        }

        let delay: number;
        if(hideMessageDelay && hideMessageDelay > 0){
            delay = hideMessageDelay;
        }else{
            delay = this.HIDE_MESSAGE_DELAY;
        }
        this.timeOut = window.setTimeout(() => {
            this.closeToast();
            delete this.timeOut;
        }, delay);
    }

}



// WEBPACK FOOTER //
// ./public/upgrade/root/toast/notification.service.ts